var exports = {
  "y": "xe7b6e3d6--22d035--links",
  "n": "xe7b6e3d6--22d035--link",
};

module.exports = exports;
